__webpack_require__.p = "/riichimahjongtrainer/";